var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seckill"},[_c('p',{staticClass:"seckill__title"},[_vm._v(_vm._s(_vm.$t('seckill_module')))]),_c('p',{staticClass:"seckill__subtitle"},[_vm._v(_vm._s(_vm.$t('giipbtctmdnntbpacpap。')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }